// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._nhzVD {
  width: 430px;
  max-width: 90vw;
}

.lRACH5 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2-5, 20px);
}

.SHX7Te {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 1.4;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.VfLy4R {
  width: 100%;
}

@media (max-width: 768px) {
  ._nhzVD {
    margin: var(--spacing-2, 16px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/MaintenanceModal/MaintenanceModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".maintenanceModal {\n  width: 430px;\n  max-width: 90vw;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2-5, 20px);\n}\n\n.message {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 1.4;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.confirmButton {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .maintenanceModal {\n    margin: var(--spacing-2, 16px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"maintenanceModal": `_nhzVD`,
	"content": `lRACH5`,
	"message": `SHX7Te`,
	"confirmButton": `VfLy4R`
};
module.exports = ___CSS_LOADER_EXPORT___;
